import { ActionTypes } from '../constants/ActionTypes';

export function errorsMsg(checkError,msg,typeAction = ActionTypes.ERROR_MSG) {
    return {
        type: typeAction,
        msg:msg,
        checkError:checkError,
    };
}



// WEBPACK FOOTER //
// ./src/actions/errors.js